import { signInWithCustomToken } from "firebase/auth";
import { auth } from "@/config/firebaseConfig.js";
import { getUtmFirst, getUtmLast } from "@/helpers/utmTracking";

/**
 * Legt einen neuen Benutzer UND ein Fahrzeug manuell an
 * und leitet den Nutzer anschließend auf die Status-Seite
 * des Fahrzeugs weiter.
 */
export async function handleSignUpWithManual(
  email,
  vorname,
  nachname,
  telefon,
  kmStand,
  marke,
  model,
  gearbox,
  fueltype,
  bodytype,
  baujahr,
  doors,
  ps,
  variant,
  modelType,
  api,
  page, // ✅ NEW
  fin = null
  // ⚠ router hier entfernen, wird im Component benutzt
) {
  try {
    console.log("[handleSignUpWithManual] start");
    const res = await fetch(`${api}/login/sign-up-with-manual`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        vorname,
        nachname,
        telefon,
        kmStand,
        marke: marke?.name ?? null,
        model: model?.name ?? null,
        variant: variant?.name ?? null,
        type: modelType?.name ?? null,
        gearbox: gearbox?.name ?? null,
        fueltype: fueltype?.name ?? null,
        bodytype: bodytype?.name ?? null,
        baujahr: baujahr?.name ?? null,
        doors: doors?.id ?? null,
        ps: ps?.name ?? null,
        fin,
        vehicleDataIds: {
          brand: marke?.id ?? null,
          model: model?.id ?? null,
          year: baujahr?.id ?? null,
          body: bodytype?.id ?? null,
          fuel: fueltype?.id ?? null,
          variant: variant?.id ?? variant?.name ?? null,
          kw: ps?.id ?? null,
          gearbox: gearbox?.id ?? null,
          doors: doors?.id ?? null,
          modelType: modelType?.id ?? null,
        },

        page: page ?? null, // ✅ NEW: pass through to backend

        utm_first: getUtmFirst(),
        utm_last: getUtmLast(),
      }),
    });

    const data = await res.json();

    console.log("[handleSignUpWithManual] response", {
      ok: res.ok,
      status: res.status,
      vehicleId: data?.vehicleId,
      price: data?.price,
      isCompleted: data?.isCompleted,
      priceCalculationAutomated: data?.ab?.priceCalculationAutomated,
    });

    if (!res.ok) {
      console.error("[handleSignUpWithManual] Backend error:", data);
      return { success: false, error: data.error || res.statusText };
    }

    const { customToken, vehicleId, price } = data;
    const priceCalculationAutomated =
      data?.ab?.priceCalculationAutomated === true ||
      data?.priceCalculationAutomated === true;

    if (!customToken || !vehicleId) {
      console.error(
        "[handleSignUpWithManual] Missing token or vehicleId:",
        data
      );
      return { success: false, error: "Missing token or vehicleId" };
    }

    // Firebase-Login
    const credential = await signInWithCustomToken(auth, customToken);
    const signedInUser = credential?.user ?? auth.currentUser;
    if (signedInUser) {
      // Do not block the redirect flow on token refresh. If refreshing fails
      // we still have an authenticated user session.
      signedInUser.getIdToken(true).catch((tokenErr) => {
        console.warn(
          "[handleSignUpWithManual] getIdToken refresh failed:",
          tokenErr
        );
      });
    } else {
      console.warn(
        "[handleSignUpWithManual] signInWithCustomToken returned no user"
      );
      return { success: false, error: "Login nach Registrierung fehlgeschlagen" };
    }

    // KEIN router.push hier mehr
    return {
      success: true,
      vehicleId,
      price: price ?? null,
      priceCalculationAutomated,
      signedInUid: signedInUser?.uid ?? null,
    };
  } catch (err) {
    console.error("[handleSignUpWithManual] Manual Sign-Up Error:", err);
    return { success: false, error: err.message };
  }
}

// ──────────────────────────────────────────────────────────────────────────────
// 2) Sign-In mit manuellen Fahrzeugdaten
// ──────────────────────────────────────────────────────────────────────────────
export async function handleSignInWithManual(
  email,
  kmStand,
  marke, // { id, name }
  model, // { id, name }
  gearbox, // { id, name }
  fueltype, // { id, name }
  bodytype, // { id, name }
  baujahr, // { id, name }
  doors, // { id, name }
  ps, // { id, name }
  variant, // { id, name }
  modelType, // { id, name }
  api,
  page, // ✅ NEW
  fin = null
) {
  try {
    const res = await fetch(`${api}/login/sign-in-with-manual`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        kmStand,
        marke: marke?.name ?? null,
        model: model?.name ?? null, // hier wird alles zusammengefasst
        variant: variant?.name ?? null,
        type: modelType?.name ?? null,
        gearbox: gearbox?.name ?? null,
        fueltype: fueltype?.name ?? null,
        bodytype: bodytype?.name ?? null,
        baujahr: baujahr?.name ?? null,
        doors: doors?.id ?? null,
        ps: ps?.name ?? null,
        fin,
        vehicleDataIds: {
          brand: marke?.id ?? null,
          model: model?.id ?? null,
          year: baujahr?.id ?? null,
          body: bodytype?.id ?? null,
          fuel: fueltype?.id ?? null,
          variant: variant?.id ?? variant?.name ?? null,
          kw: ps?.id ?? null,
          gearbox: gearbox?.id ?? null,
          doors: doors?.id ?? null,
          modelType: modelType?.id ?? null,
        },

        page: page ?? null, // ✅ NEW: pass through to backend

        utm_first: getUtmFirst(),
        utm_last: getUtmLast(),
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      console.error(
        "[handleSignInWithManual] Response error:",
        data.error || res.statusText
      );
      throw new Error(data.error || res.statusText);
    }

    // Der Endpunkt sendet dem Client per E-Mail einen Login-Link; es ist kein
    // weiteres Firebase-Token hier nötig.
    return true;
  } catch (err) {
    console.error("[handleSignInWithManual] Manual Sign-In Error:", err);
    return false;
  }
}
